import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Table,
} from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import { useState } from "react";

class EditTransactionDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
      editRowIndex: -1,
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);

    this.products1 = [
      {
        id: "01",
        categories: "HPHT",
        weight: 1.50,
        pieces: 1,
        rate: 100,
        amount: 150,
      },
      {
        id: "02",
        categories: "LPHT",
        weight: 1.50,
        pieces: 1,
        rate: 100,
        amount: 150,
      },
      {
        id: "03",
        categories: "REAL",
        weight: 1.50,
        pieces: 1,
        rate: 100,
        amount: 150,
      },
      {
        id: "04",
        categories: "JIRAM",
        weight: 1.50,
        pieces: 1,
        rate: 100,
        amount: 150,
      },
    ];

    this.products2 = [
      {
        id: "01",
        categories: "HPHT",
        weight: 1.50,
        pieces: 1,
        rate: 100,
        amount: 150,
      },
      {
        id: "02",
        categories: "HPHT",
        weight: 1.50,
        pieces: 1,
        rate: 100,
        amount: 150,
      },
      {
        id: "03",
        categories: "LPHT",
        weight: 1.50,
        pieces: 1,
        rate: 100,
        amount: 150,
      },
      {
        id: "04",
        categories: "REAL",
        weight: 1.50,
        pieces: 1,
        rate: 100,
        amount: 150,
      },
    ];
  }

  handleSubmit(e) {
    e.preventDefault();

    const modifiedV = { ...this.state.validation };

    this.setState({ validation: modifiedV });
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title

    this.columns1 = [
      {
        dataField: "id",
         text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
      },
      {
        dataField: "categories",
        text: "Categories",
        footer: "",
      },
      {
        dataField: "weight",
        text: `${this.props.t('Weight / Carat')}`,
        footer: columnData =>
        columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
      },
      {
        dataField: "pieces",
        text:`${this.props.t('Pieces')}`,
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
      },
      {
        dataField: "rate",
        text: `${this.props.t('Rate')}`,
        footer: "",
      },
      {
        dataField: "amount",
        text: `${this.props.t('Amount')}`,
        footer: columnData =>
        columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
      },
    ];

    this.columns2 = [
      {
        dataField: "id",
         text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
      },
      {
        dataField: "categories",
        text: "Categories",
        footer: "",
      },
      {
        dataField: "weight",
        text: `${this.props.t('Weight / Carat')}`,
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
      },
      {
        dataField: "pieces",
        text:`${this.props.t('Pieces')}`,
        footer: columnData =>
        columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
      },
      {
        dataField: "rate",
        text: `${this.props.t('Rate')}`,
        footer: "",
      },
      {
        dataField: "amount",
        text: `${this.props.t('Amount')}`,
        footer: columnData =>
        columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
      },
    ];
    document.title = "transaction-history";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="Transaction Details" />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={{
                  invoiceID: (this.state && this.state.invoiceID) || "",
                  partyName: (this.state && this.state.partyName) || "",
                  date: (this.state && this.state.date) || "",
                  notes: (this.state && this.state.notes) || "",
                }}
                validationSchema={Yup.object().shape({
                  attachment: Yup.mixed()
                    .nullable()
                    .notRequired()
                    .test(
                      "FILE_SIZE",
                      "Uploaded file is too big.",
                      value => !value || (value && value.size <= FILE_SIZE)
                    )
                    .test(
                      "FILE_FORMAT",
                      "Uploaded file has unsupported format.",
                      value =>
                        !value ||
                        (value && SUPPORTED_FORMATS.includes(value.type))
                    ),
                  invoiceID: Yup.string().required("This value is required"),
                  partyName: Yup.string().required("This value is required"),
                  date: Yup.string().required("This value is required"),
                  notes: Yup.string().required("This value is required"),
                })}
                onSubmit={values => {}}
              >
                {({ errors, status, touched, values }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <div className="row">
                        <div className="d-md-flex d-block justify-content-between px-4">
                          <div>
                            <h4 className="text-black fw-bold mb-4">
                              Edit Transaction Details
                            </h4>
                          </div>
                          {/* <div>
                            <label
                              htmlFor="date"
                              className="fs-4 pe-2 text-black fw-bold"
                            >
                              Date:
                            </label>
                            <input type="date" className="fs-4 border-0" />
                          </div> */}
                        </div>
                        <div className="col-xl-8 col-12">
                          <CardBody>
                            <Row>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="partyName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    Party
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.partyName && touched.partyName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="text"
                                    name="partyName"
                                    placeholder="XYZ Diamond"
                                  />
                                  <ErrorMessage
                                    name="partyName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="invoiceID"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    Invoice ID
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.invoiceID && touched.invoiceID
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="text"
                                    name="invoiceID"
                                    placeholder="INVOICE000123"
                                  />
                                  <ErrorMessage
                                    name="invoiceID"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="date"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    Invoice Date
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.date && touched.date
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="text"
                                    name="date"
                                    placeholder="23-Jun-22"
                                  />
                                  <ErrorMessage
                                    name="date"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </Row>
                          </CardBody>
                        </div>
                        <div className="col-xl-4 col-12 pt-3">
                          <div className="px-4">
                            <div className="row border-gray py-3">
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Contact Person")} :</h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>Brooklyn Simmons</h5>
                              </div>
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Mobile no.1")} : </h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>+91 (132)(564)(9872)</h5>
                              </div>
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Mobile no.2")} : </h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>+91 (132)(564)(9872)</h5>
                              </div>
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Email Address")} : </h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>xyzdiamond12@gmail.com</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row px-3 pt-3">
                        <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                          <div>
                            <h4 className="fw-bold pb-3 text-black">
                              1.Jangad Id - STOCK0000123 [ABC Diamond Unit
                              (Internal)]
                            </h4>
                          </div>
                          <div>
                            <div className="pt-3 pt-xxl-0">
                              <h4 className="d-inline text-black fw-bold pe-3">
                                {this.props.t('From Date')}: 01/01/2022
                              </h4>
                              <h4 className="d-inline text-black fw-bold">
                                {this.props.t('To Date')}: 25/01/2022
                              </h4>
                            </div>
                          </div>
                        </div>
                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="id"
                            classes="foo"
                            headerClasses="background-light fs-5"
                            footerClasses="background-light fs-5"
                            bootstrap4={true}
                            data={this.products1}
                            columns={this.columns1}
                          />
                        </div>
                      </div>
                      <div className="row px-3 pt-4">
                        <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                          <div>
                            <h4 className="fw-bold pb-3 text-black">
                              2.Jangad Id - STOCK0000124 [ABC Diamond Unit
                              (Internal)]
                            </h4>
                          </div>
                          <div>
                            <div className="pt-3 pt-xxl-0">
                              <h4 className="d-inline text-black fw-bold pe-3">
                                {this.props.t('From Date')}: 02/01/2022
                              </h4>
                              <h4 className="d-inline text-black fw-bold">
                                {this.props.t('To Date')}: 25/01/2022
                              </h4>
                            </div>
                          </div>
                        </div>
                        <div className="table-responsive">
                          <BootstrapTable
                            classes="foo"
                            keyField="id"
                            headerClasses="background-light fs-5"
                            footerClasses="background-light fs-5"
                            bootstrap4={true}
                            data={this.products2}
                            columns={this.columns2}
                          />
                        </div>
                      </div>

                      <div className="mb-3 row px-3 pt-3">
                        <Label
                          htmlFor="notes"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            Transaction Notes
                          </h5>
                        </Label>
                        <div className="col-md-10">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.notes && touched.notes
                                ? " is-invalid"
                                : "")
                            }
                            type="text"
                            name="notes"
                            as="textarea"
                            rows="5"
                          />
                          <ErrorMessage
                            name="notes"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>

                      <div className="col-md-12 text-center text-md-end pe-3 py-5">
                        <div className="btn-group">
                          <Button
                            color="primary"
                            className="fs-4 px-5"
                            type="submit"
                          >
                            Submit
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default EditTransactionDetail;
